<template>
  <ul v-if="tips.length" class="text-body text-grey-body list-none mt-16">
    <li v-for="tip in tips" :key="tip" class="flex items-center first:mt-0 mt-16">
      <TickIcon class="shrink-0 mr-8 text-brand" :height="18" :width="18" :color="iconColor" aria-hidden="true" />
      <span>{{ tip }}</span>
    </li>
  </ul>
</template>

<script lang="ts">
import TickIcon from '../../graphics/icons/TickIcon.vue';

export default {
  name: 'CheckmarkList',
  components: { TickIcon },
  props: {
    tips: {
      default: () => [''],
      type: Array<String>,
    },
    iconColor: {
      type: String,
      default: '#FF0064',
    },
  },
};
</script>
